module.exports = __webpack_public_path__ + "res/Roboto-BlackItalic-webfont.eot?2135e78af10078f722cd4614c00e88c9";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-BlackItalic-webfont.eot
// module id = 86
// module chunks = 0